import {Base} from "@/api/Base"

export class PolicyDelete extends Base {
    path = "policy/delete"
}